import { Person, NotifierRolesByServer } from "@/types";
import React from "react";
import { useMatch, useNavigate } from "react-router-dom";
import { PersonSummary } from "./PersonSummary";
interface ExpressPersonSummaryI {
  person: Person;
}
export const ExpressPersonSummary: React.FC<ExpressPersonSummaryI> = ({ person }) => {
  const match = useMatch("/express/:slug/*");
  const navigate = useNavigate();
  const onEditNotifier = React.useCallback(() => {
    if (!person.roles || person.roles.length === 0) {
      navigate(`${match?.pathnameBase}/notifier`);
    } else if (person.roles.includes(NotifierRolesByServer.Nok)) {
      navigate(`${match?.pathnameBase}/nok`);
    } else if (person.roles.includes(NotifierRolesByServer.Executor)) {
      navigate(`${match?.pathnameBase}/executor`);
    } else {
      navigate(`${match?.pathnameBase}/notifier`);
    }
  }, [navigate, match, person]);

  return <PersonSummary onEdit={onEditNotifier} person={person} />;
};
